module.exports = __webpack_public_path__ + "img/stateError.a22b17b1.svg";